module.exports = __webpack_public_path__ + "img/share_page_down_background_2.f34ae9c7.png";